var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('signup-reset-password-layout', {
    scopedSlots: _vm._u([{
      key: "form-template",
      fn: function () {
        return [_c('b-overlay', {
          attrs: {
            "show": _vm.loading,
            "spinner-variant": "primary",
            "spinner-type": "grow"
          }
        }, [_c('div', {
          staticClass: "reset-password-card",
          attrs: {
            "align-v": "center"
          }
        }, [_c('div', {
          staticClass: "header-container w-100"
        }, [_c('div', {
          staticClass: "reset-password-header px-4 pt-4"
        }, [_c('img', {
          staticClass: "logo-img",
          attrs: {
            "src": require("@/assets/images/signup/logo.svg"),
            "alt": "Cascade Logo"
          }
        }), _c('selector', {
          staticClass: "p-1"
        })], 1)]), _c('b-row', {
          staticClass: "form h-100",
          attrs: {
            "align-v": "center"
          }
        }, [_c('b-col', [_c('reset-password-form', {
          attrs: {
            "error": _vm.resetError
          },
          on: {
            "submit": _vm.onSubmit
          }
        })], 1)], 1)], 1)])];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }